const isBrowser = typeof window !== 'undefined'

export default function LocalUrl({ path }) {
  let origin = ''
  if (isBrowser) {
    origin = window.location.origin
  }
  return <>{`${origin}${path}`}</>
}
